export const images = {
  stack: 'https://cdn.magicpatterns.com/patterns/generated-images/6207787d-799c-4a11-8fc7-2f8ad6fc55f1.jpg',
  spread: 'https://cdn.magicpatterns.com/uploads/qSwqoreDLPYqHaW7kwZCRo/pasted-image.png',
  cover: 'https://cdn.magicpatterns.com/uploads/9phQNuwsCzos7uBFboCvrK/pasted-image.png'
};
export const price = {
  total: '$123',
  today: '$27'
};
export const insidePages = [{
  src: 'https://cdn.magicpatterns.com/uploads/dWEjVVApHEapKZ8bdvqKmB/Captura_de_pantalla_2026-10-16_143305.png',
  alt: 'Journal page 7: When you prioritize yourself'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8VqfAS8Jo87yX4aW1umgmC/Captura_de_pantalla_2026-10-16_143313.png',
  alt: 'Journal page 8: Benefits of putting you first'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s9oWQb1RLFXnZc8w8NBdcB/Captura_de_pantalla_2026-10-16_143326.png',
  alt: 'Journal page 13: Habits that sabotage you'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/euroaHx2FcoZgqnFsg8F7F/Captura_de_pantalla_2026-10-16_143339.png',
  alt: 'Journal page 19: List of affirmations'
}];
export const checkoutUrl = 'https://priority-journal.impultienda.ar/checkout';
// Paste your video link here (YouTube embed, Vimeo, etc.)
export const helpVideoUrl = '';
export const painPoints = [{
  lead: 'You get to the end of the day exhausted',
  rest: 'and feel like you did everything… except what really mattered. Everyone else’s tasks got done. Yours, pushed to tomorrow again.'
}, {
  lead: 'You have a thousand things on your mind',
  rest: 'and don’t know where to start. That feeling that everything is urgent and you’re last on the list.'
}, {
  lead: 'You’ve tried getting organized with apps, notebooks, lists…',
  rest: 'and you give up after three days because it feels like one more obligation.'
}, {
  lead: 'You’ve been telling yourself "when I have time, I’ll take better care of myself" for months.',
  rest: 'But that moment never comes, because no one is going to give it to you. You have to take it.'
}, {
  lead: 'You know what you want to achieve,',
  rest: 'but the day slips away and you’re still in the same place. Not moving forward. Not feeling like yourself.'
}];
export const benefits = [{
  icon: 'heart',
  title: 'You’ll learn to prioritize yourself without guilt',
  text: 'Because it’s not about doing more. It’s about giving yourself the place you deserve in your own life. And that starts here.'
}, {
  icon: 'brain',
  title: 'No more juggling a thousand thoughts at once',
  text: 'Writing will bring order from the inside. Like a conversation with yourself that finally brings clarity, peace, and direction.'
}, {
  icon: 'calendar',
  title: 'You’ll have a sacred space to plan, reflect, and review your week',
  text: 'No complications, no impossible demands. A ritual that’s yours, just for you, that actually works.'
}, {
  icon: 'sparkles',
  title: 'You’ll start doing more of the things you truly love',
  text: 'You’ll reconnect with what nourishes you and makes you feel alive. Because that counts too. A lot.'
}] as const;
export const bonuses = [{
  number: 1,
  title: 'Your Ideal Week Template',
  value: '$9',
  text: 'Design the week you want to live, not the one that just happens to you. Space for you, your goals, and what nourishes you.'
}, {
  number: 2,
  title: 'Habit List Template',
  value: '$17',
  text: 'Organize the habits you want to build in one place. Frequency, tracking, and progress, so they move from intention to real action.'
}, {
  number: 3,
  title: 'Daily Priorities Template',
  value: '$15',
  text: 'Start every morning knowing what matters most, so you never reach the end of the day again without moving forward on what truly counts.'
}, {
  number: 4,
  title: 'Dreams & Goals Map Template',
  value: '$17',
  text: 'Get everything you want to achieve out of your head and onto paper. A visual map so your goals stop being dreams and become a real plan.'
}];
export const inclusions = ['Positive affirmations list', 'Letter to my future self', 'Self-sabotaging habits template', 'Vision board', 'Template to discover who I really am', 'Self-love goals template', 'Monthly progress template', 'Weekly templates and much more', 'Reflective activities', '30 challenges to prioritize yourself', 'Weekly check-in', 'Motivational quotes'];
export const valueStack = [{
  item: 'Complete Priority Journal PDF',
  value: '$65'
}, {
  item: 'Daily Priorities Template PDF',
  value: '$15'
}, {
  item: 'Habit List Template PDF',
  value: '$17'
}, {
  item: 'Your Ideal Week Template PDF',
  value: '$9'
}, {
  item: 'Dreams & Goals Map Template PDF',
  value: '$17'
}];
export const testimonials = [{
  name: 'Laura M.',
  quote: 'For the first time in years, I end the day feeling like I did something for me. The daily challenges are short and feel doable.'
}, {
  name: 'Daniela R.',
  quote: 'I printed it and keep it on my nightstand. The weekly check-in changed the way I see my Sundays.'
}, {
  name: 'Camila V.',
  quote: 'I tried a thousand apps and none of them stuck. This is different: writing clears my head and I’m no longer just putting out fires.'
}];
export const faqs = [{
  q: 'How do I receive my journal?',
  a: 'Right after your purchase you’ll get an email with the download link for the journal and all 4 bonuses. No waiting.'
}, {
  q: 'Is it hard to use?',
  a: 'Not at all. Every page guides you step by step. All you need is a few minutes a day and the desire to make room for yourself.'
}, {
  q: 'Is it a physical product?',
  a: 'No. It’s a digital PDF product, so there’s no shipping and you get it instantly, wherever you are.'
}, {
  q: 'How soon will I see results?',
  a: 'Many people feel more clarity in the very first week. The method is designed so that in 30 days, prioritizing yourself becomes a habit.'
}, {
  q: 'Can I print it?',
  a: 'Yes. It has over 160 printable pages. Print the whole thing, just the templates you need, or use it on your tablet.'
}];
export const recentPurchases = [{
  name: 'Emily',
  place: 'United States',
  ago: '1 minute ago'
}, {
  name: 'Olivia',
  place: 'Canada',
  ago: '3 minutes ago'
}, {
  name: 'Sophie',
  place: 'United Kingdom',
  ago: '5 minutes ago'
}, {
  name: 'Grace',
  place: 'Australia',
  ago: '8 minutes ago'
}, {
  name: 'Hannah',
  place: 'Ireland',
  ago: '11 minutes ago'
}, {
  name: 'Chloe',
  place: 'New Zealand',
  ago: '14 minutes ago'
}];